import axios from 'axios';
import {queryToString} from '@/common/util';

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.transformRequest = [function (data) {
    return queryToString(data, true);
}];
const host = `//${location.host}`;
// const host = '';
// 获取省份城市列表
export const getAllProvinceCity = () => {
    return axios
        .get(host + '/landingpage/get/allProvinceCityInfo')
        .then(res => res.data);
};

/**
 * 获取经销商列表
 * @param {*} seriesId 
 * @param {*} specId 非必填
 * @param {*} cityId 
 */
export const getDealerList = (seriesId = '', specId = '', cityId = '') => {
    return axios
        .get(`${host}/api/getDealerInfo?seriesIds=${seriesId}&specId=${specId}&cityId=${cityId}&type=ctrl&appKey=leads&complement=1`)
        .then(res => res.data)
};

/**
 * 获取红旗经销商文章
 * @param {*} seriesId 
 * @param {*} cityId 
 */
export const getArticleList = (cityId = '') =>{
    return axios.get(`${host}/third/dealer/news?cityId=${cityId}`)
    .then(res => res.data)
}


/**
 * 根据车系id获取车系,车型信息
 * @param {*} seriesId 
 * @param {*} pictureType 图片类型
 *  1 112x84
 *  2 240x180
 *  3 480x360
 *  4 原图
 */
export const getSeriesInfo = (seriesId, pictureType = 2) => {
    return axios.get(`${host}/api/carInfo?seriesId=${seriesId}&pictureType=${pictureType}`);
};

/**
 * 获取车型价格
 * @param {*} seriesId 
 * @param {*} specId 
 * @param {*} cityId 
 * dealerPrice 经销商报价
 * price 官方指导价
 * priceOff 差价
 */
export const getSpecPrice = (seriesId, specId, cityId) => {
    return axios
        .get(`${host}/api/specPrice?seriesId=${seriesId}&specId=${specId}&cityId=${cityId}`)
        .then(res => res.data || {});
};

/**
 * 获取车型价格, 上月成交价, 经销商当月报价平均值
 * @param {*} specId 
 * @param {*} cityId 
 */
export const getAllPrice = (specId, cityId) => {
    return axios
        .get(`${host}/third/specAllPrice?cityId=${cityId}&specId=${specId}`)
        .then(res => res.data || {});
};

/**
 * 获取位置信息 IP定位
 */
export const getPositionInfo = ()=> {
    return axios
        .get(host + '/api/IP/getCityInfo')
        .then(res => res.data || {});
};
export const getCityFromIP = getPositionInfo;
/**
 * 获取用户手机号, 姓名
 */
export const getUserInfo = () => {
    return axios
        .get(host + '/landingpage/getUserInfo')
        .then(res => res.data || {});
};

export const submitLeads = params => {
    return axios({
        // url: '//leads.api.autohome.com.cn/leads/monitor/lands',
        url: '//leads.api.autohome.com.cn/monitor/lands',
        method: 'post',
        data: params
    }).then(res => res.data || {});
};